module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/fbc0674b961eb36b3f0ffe37e1a292a4.png";